import { TdsSpinner } from '@scania/tegel-react';
import { type ReactElement } from 'react';

interface SpinnerProperties {
  readonly size?: 'xs' | 'sm' | 'md' | 'lg';
  readonly variant?: 'standard' | 'inverted';
  readonly dataTestId?: string;
}

const Spinner = ({ size = 'sm', variant = 'standard', dataTestId }: SpinnerProperties): ReactElement => {
  return (
    <div role="status" aria-live="polite" aria-busy="true" data-testid={dataTestId}>
      <TdsSpinner size={size} variant={variant} />
    </div>
  );
};

export default Spinner;
